import Logout from './Logout'

export default Logout
// eslint-disable-next-line import/export
export * from './Logout'
